<template>
  <div class="mail-list">
    <div class="upload-input">
      <el-input placeholder="任务名" v-model="missionName" class="mission-name"></el-input>
      <el-button size="mini" @click="uploadMail">上传邮件列表{{mailListUpEnd ? '(已上传)' : ''}}</el-button>
      <el-button size="mini" @click="uploadTemplate">上传模板{{mailTemplateUpEnd ? '(已上传)' : ''}}</el-button>
      <el-button size="mini" @click="addMission">增加任务</el-button>
    </div>
    <c-table ref="table" :columns="columns" url="/emailj">
      <el-table-column slot="taskname" show-overflow-tooltip label="任务名">
        <template v-slot="{row}">
          <span>{{row.taskname}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="mailboxnumber" show-overflow-tooltip label="收件人数">
        <template v-slot="{row}">
          <span>{{row.mailboxnumber}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="id" show-overflow-tooltip label="模板">
        <template v-slot="{row}">
          <el-button type="text" @click="openTemplate(row)">模板{{`(${row.id})`}}</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="shoujian_list" show-overflow-tooltip label="收件列表">
        <template v-slot="{row}">
          <el-button type="text" @click="goToReceiveDetail(row)">列表</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="status" show-overflow-tooltip label="发送情况">
        <template v-slot="{row}">
          <el-button type="text" @click="goToStatus(row)">{{row.status}}</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="email_time" show-overflow-tooltip label="创建时间">
        <template v-slot="{row}">
          <span>{{row.email_time}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="email_sendtime" show-overflow-tooltip label="发送时间">
        <template v-slot="{row}">
          <span>{{row.email_sendtime}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="renwu_name" show-overflow-tooltip label="操作">
        <template v-slot="{row}">
          <el-button type="text">删除</el-button>
        </template>
      </el-table-column>
    </c-table>
    <el-upload
      style="display:none;"
      ref="uploadMail"
      :show-file-list="false"
      action=""
      :on-change="onMailSuccess"
    ></el-upload>
    <el-upload
      style="display:none;"
      ref="uploadTemplate"
      :show-file-list="false"
      action=""
      :on-change="onTemplateSuccess"
    ></el-upload>
  </div>
</template>
<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      columns: [
        { slot: 'taskname' },
        { slot: 'mailboxnumber' },
        { slot: 'id' },
        { slot: 'shoujian_list' },
        { slot: 'status' },
        { slot: 'email_time' },
        { slot: 'email_sendtime' }
      ],
      mailListUp: null,
      mailTemplateUp: null,
      missionName: '',
      mailListUpEnd: false,
      mailTemplateUpEnd: false
    }
  },
  methods: {
    uploadMail (mail) {
      this.mailListUp = mail
      this.$refs.uploadMail.$refs[ 'upload-inner' ].$refs.input.click()
    },
    uploadTemplate (template) {
      this.mailTemplateUp = template
      this.$refs.uploadTemplate.$refs[ 'upload-inner' ].$refs.input.click()
    },
    async addMission () {
      const { missionName, mailListUp, mailTemplateUp } = this
      if (!missionName) {
        this.$notify.error({
          title: '错误',
          message: '请输入任务名'
        })
        return false
      }
      if (!mailListUp) {
        this.$notify.error({
          title: '错误',
          message: '未上传邮件列表'
        })
        return false
      }
      if (!mailTemplateUp) {
        this.$notify.error({
          title: '错误',
          message: '未上传邮件模板'
        })
        return false
      }
      let formdata = new FormData()
      formdata.append('name', missionName)
      formdata.append('list', mailListUp)
      formdata.append('modular', mailTemplateUp)
      const res = await this.$http.post('/emailj/add', formdata)
      if (res.data.status === 'success') {
        this.mailListUp = null
        this.mailTemplateUp = null
        this.missionName = ''
        this.$refs.table.reload()
      }
    },
    onMailSuccess (res) {
      this.mailListUp = res.raw
      this.mailListUpEnd = true
    },
    onTemplateSuccess (res) {
      this.mailTemplateUp = res.raw
      this.mailTemplateUpEnd = true
    },
    // 跳转到收件列表页面
    goToReceiveDetail (row) {
      this.$router.push(`/email/receive_list?id=${row.id}`)
    },
    // 跳转到发送情况列表页面
    goToStatus (row) {
      this.$router.push(`/email/status_list?id=${row.id}`)
    },
    openTemplate (row) {
      this.$router.push(`/email/template?id=${row.id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-input {
  padding: 0 0 20px;
  .mission-name {
    width: 200px;
    margin-right: 10px;
  }
  button {
    height: 32px;
  }
}
</style>
